<template>
    <div class="login-container">
      
      <div class="login-box">
        <img src="@/assets/logo.png" alt="Logo" class="form-logo">
        <h1>Reporte de gastos</h1>
        <button @click="signIn" class="login-btn">Iniciar Sesión con Microsoft</button>
      </div>
    </div>
  </template>
  
  <script>
  import { logIn } from '@/api/api';

  export default {
    name: 'LoginPage',
    methods: {
      async signIn() {
        await logIn();
      }
    },
  };
  </script>
  
  <style scoped>
  .login-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: #f4f4f4;
  }
  
  .login-box {
    background: white;
    padding: 40px 20px;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    text-align: center;
    width: 100%;
    max-width: 600px; /* Máximo ancho en pantallas grandes */
    margin: 0 20px; /* Márgenes en pantallas pequeñas */
  }
  
  h1 {
    margin-bottom: 30px;
    font-size: 2rem;
    color: #333;
  }
  
  .login-btn {
    background-color: #0078d4;
    color: white;
    font-size: 1rem;
    padding: 12px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  
  .login-btn:hover {
    background-color: #005a9e;
  }
  
  .login-btn:focus {
    outline: none;
    box-shadow: 0 0 0 4px rgba(0, 120, 212, 0.4);
  }
  
  /* Media query para pantallas menores a 600px */
  @media (max-width: 600px) {
    .login-box {
      width: 100%; /* Ancho completo */
      max-width: 100%; /* Sin límite de ancho */
      margin: 0 10px; /* Márgenes pequeños */
    }
  }
  </style>
  